import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bc4c5be"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = {
  class: "cinema__series",
  tabindex: "0"
}
const _hoisted_3 = { class: "cinema__series-content" }
const _hoisted_4 = { class: "cinema__series-poster" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  key: 1,
  class: "empty"
}
const _hoisted_7 = { class: "cinema__series-info" }
const _hoisted_8 = { class: "cinema__series-title" }
const _hoisted_9 = { class: "cinema__series-year" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cinema__series-separator" }, null, -1))
const _hoisted_11 = { class: "cinema__series-content-header" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "cinema__series-content-title" }, " 选集 ", -1))
const _hoisted_13 = { class: "cinema__series-list" }
const _hoisted_14 = ["title", "onClick"]
const _hoisted_15 = { class: "cinema__series-videoicon" }
const _hoisted_16 = { class: "cinema__series-videoname" }

import { onMounted, ref, computed } from 'vue'
import SVGIcon from '../SVGIcon.vue'
import SlideText from '../SlideText.vue'
import { IconClose, IconTvVideo } from '@xunlei/thunder-icon-vue'
import { usePromisifyDialog } from '@shared/utils/dialog'
import { store } from '@remote/store'
import { useCinemaStore } from '@remote/store/cinema'
import debounce from 'lodash/debounce'
import { stat } from '@remote/utils/stat'
import { toast } from '@remote/utils'
import { getDramas as getDramasApi, getDramasByInfo} from '@remote/api/nfo'

interface IProps {
  nfo: API_NFO.NFO
}

interface IEmits {
  (e: 'dialog-close'): void
}


export default /*#__PURE__*/_defineComponent({
  props: {
    nfo: null
  },
  emits: ["dialog-close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'dialog-close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  nfo: API_NFO.NFO
}

function logs (..._args) {
  console.log('[片库][TV选集面板]', ..._args)
}





const isMountedRef = ref(false)
const dramas = ref<API_NFO.Drama[]>([])
const isImageErrored = ref(false)

const { close } = usePromisifyDialog(emit)
const cinemaStore = useCinemaStore()
const episodes = computed(() => {
  return dramas.value.length ? dramas.value : props.nfo.scrape_result?.dramas ?? []
})


const imgURL = computed(() => {
  if (isImageErrored.value) return ''
  const scrape_result = props.nfo.scrape_result
  if (!scrape_result) return ''
  return scrape_result.poster_horizontal || scrape_result.poster_vertical || scrape_result?.post_url && scrape_result?.post_url[0] || ''
})

const play = debounce((episode: API_NFO.Drama) => {
  onClose()
  if (episode.file_id) {
    cinemaStore.setPlaying(true)
    store.dispatch('getFileInfo', {
      space: 'hezi',
      apiUrl: '/drive/v1/files',
      path: encodeURIComponent(episode?.real_path || ''),
      size: String(episode?.file_size),
      id: episode.file_id,
      usage: 'PLAY',
      theme: 'dark',
      scene: 'nfo',
      mime_type: 'video/*',
      name: episode.file_name,
    }).then(() => {
      cinemaStore.refreshRecentNFOList()
    }).catch(() => {
      toast('播放失败，请检查文件是否存在')
    }).finally(() => {
      cinemaStore.setPlaying(false)
    })
  }
}, 500, {
  leading: true,
  trailing: false,
})

onMounted(async () => {
  logs('nfo:', props.nfo)
  if (store.getters.isXlBox) {
    await getDramas()
    logs('dramas:', dramas.value)
  }
  setTimeout(() => {
    isMountedRef.value = true
  }, 0)
  stat({
    action: 'cinema_tele_card_detail_page_show',
    data: {
      scraper_name: props.nfo.scrape_result?.trans_name,
      origin_name: props.nfo.video_info?.file_name,
      tele_episode_num: (props.nfo.scrape_result?.dramas ?? []).length,
    },
  })
})

function onClose () {
  isMountedRef.value = false
  setTimeout(() => {
    close(null)
  }, 300)
}

async function getDramas () {
  let result
  if (props.nfo.scrape_result?.id) {
    result = await getDramasApi(props.nfo.scrape_result?.id as number)
  } else {
    result = await getDramasByInfo({name: props.nfo.scrape_result?.name as string, year: props.nfo.scrape_result?.year as string})
  }
  if (result?.length) {
    dramas.value = result
  }
}

function reduceFilename (drama: API_NFO.Drama) {
  if (!drama) return ''
  const name = drama.short_name || drama.trans_name || drama.name
  const season = drama.season ? +drama.season : 0
  const episode = drama.episode ? +drama.episode : 0
  const nfoName = [
    name,
    season ? `第${season}季` : '',
    episode ? `第${episode}集` : '',
  ].filter(label => !!label).join('·')
  const fileName = drama.file_name || ''
  if (episode) return nfoName
  return fileName
}

function onPosterError () {
  isImageErrored.value = true
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass(["pop-wrapper pop-wrapper-series", { 'is-mounted': isMountedRef.value }]),
      onClick: _withModifiers(onClose, ["self"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_unref(imgURL))
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: _normalizeClass(["poster-picture", {
                'is-err': isImageErrored.value,
              }]),
                  src: _unref(imgURL),
                  alt: __props.nfo?.scrape_result?.trans_name,
                  onError: onPosterError
                }, null, 42, _hoisted_5))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_unref(IconTvVideo), {
                    width: "56",
                    height: "56"
                  })
                ]))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h3", _hoisted_8, _toDisplayString(__props.nfo?.scrape_result?.trans_name), 1),
            _createElementVNode("p", _hoisted_9, _toDisplayString(__props.nfo?.scrape_result?.year), 1)
          ]),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("span", {
              class: "cinema__series-content-close",
              onClick: onClose
            }, [
              _createVNode(_unref(IconClose), {
                width: "24",
                height: "24"
              })
            ])
          ]),
          _createElementVNode("ul", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(episodes), (episode) => {
              return (_openBlock(), _createElementBlock("li", {
                title: episode.file_name,
                key: episode.file_name,
                class: "cinema__series-listitem",
                onClick: ($event: any) => (_unref(play)(episode))
              }, [
                _createElementVNode("span", _hoisted_15, [
                  _createVNode(SVGIcon, { name: "play" })
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(SlideText, {
                    text: reduceFilename(episode),
                    speed: 50,
                    delay: 1000
                  }, null, 8, ["text"])
                ])
              ], 8, _hoisted_14))
            }), 128))
          ])
        ])
      ])
    ], 10, _hoisted_1)
  ]))
}
}

})